<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <router-link
              :to="{ path: '/Vouchers/Create' }"
              class="vs-component vs-button bg_l_green"
            >
              <feather-icon
                icon="PlusIcon"
                svgClasses="h-4 w-4"
                class="ico"
                v-has-permission="permission76"
              />{{ $t("AddVoucher") }}
            </router-link>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Title'), sort: 'Title' },
                { title: $t('Contract'), sort: 'Contract' },
                { title: $t('StartDate'), sort: 'StartClock' },
                { title: $t('EndDate'), sort: 'ExpireClock' }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 40%">
                  {{ row.title }}
                </td>
                <td style="width: 20%">
                  {{ row.setting ? row.setting.contractId : "ندارد" }}
                </td>
                <td style="width: 19%; direction: ltr">
                  {{ row.expirationInfo.startClock }}
                </td>
                <td style="width: 19%; direction: ltr">
                  {{ row.expirationInfo.expireClock }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "saleManagement_Vouchers_Index",
  components: {
    DataGrid
  },
  data() {
    return {
      permission76: "CreateVoucher",
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "Promotion/api/Vouchers"
      },
      gridSearchData: {
        keyword: ""
      }
    };
  }
};
</script>
